export default "__VITE_ASSET__CbsHL7gL__"